import Vue from "vue"
import Vuex from "vuex"
import { AppStore } from "./AppStore.js"
import { product } from "./ProductoStore.js"
import { CajaStore } from "./CajaStore.js"
import { OrdenStore } from "./OrdenStore.js"
import { UsuarioStore } from "./UsuarioStore.js"

Vue.use(Vuex)

export const store = new Vuex.Store({
    modules: {
        AppStore,
        CajaStore,
        OrdenStore,
        UsuarioStore,
        product,
    }
})